import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { SocialNetwork } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for social network list query
const CACHE_TIME = 30 * 60 * 1000;

type QueryOptions = {
  enabled?: boolean;
};

export const useSocialNetworksQuery = (options?: QueryOptions) => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['socialNetworks', apiUrl],
    queryFn: () => fetchSocialNetworks(apiUrl),
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
    enabled: !!apiUrl && (options?.enabled ?? true),
  });
};

const fetchSocialNetworks = async (apiUrl: string): Promise<SocialNetwork[]> => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<SocialNetwork[]>(`${apiUrl}${API.endpoints.socialNetworks}`, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
